@if (resolvedTimezone) {
<div class="flex flex-row items-center gap-4 mt-[2px]" nz-popover [nzPopoverContent]="contentTemplate" nzPopoverPlacement="right">
  <twaice-fe-svg-icon name="clock" source="tabler" size="16px" class="mt-[-1px]"></twaice-fe-svg-icon>
  <div class="text-sm">{{ now$ | async | twDate: 'HH:mm' }}</div>
  <div class="text-sm text-tertiary-text">{{ getDisplayTimezone(resolvedTimezone) }}</div>
</div>
}

<ng-template #contentTemplate>
  @if (userTimezone !== CustomUserTimezone.STORAGE_TIME) {
  <div class="flex flex-row items-center gap-4">
    <div class="text-sm">Selected time:</div>
    <div class="text-sm">{{ now$ | async | twDate: 'HH:mm' }}</div>
    <div class="text-sm text-tertiary-text">
      {{ getDisplayTimezone(resolvedTimezone) }}, {{ getTimezoneOffsetFromUtc(resolvedTimezone) }}
    </div>
  </div>
  } @if (storageTimezone) {
  <div class="flex flex-row items-center gap-4">
    <div class="text-sm">Storage time:</div>
    <div class="text-sm">{{ now$ | async | twDate: 'HH:mm' : 'STORAGE_TIME' }}</div>
    <div class="text-sm text-tertiary-text">
      {{ getDisplayTimezone(storageTimezone) }}, {{ getTimezoneOffsetFromUtc(storageTimezone) }}
    </div>
  </div>
  }
</ng-template>
